/* eslint-disable no-control-regex */
export const appTitle = "Talent Management";
export const domain = "adentis.pt";

export const adnPageSize = 14;

export const emailRegex = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;

export const emailAdentisRegex =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@adentis\.pt$/;

export const emailInternalRegex =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;

export const dateFormat = "DD-MM-YYYY";

export const urlRegex =
  /^((https?):\/\/)?([w|W]{3}\.)+[a-zA-Z0-9\-.]{3,}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;

/**
 * Password validation RegEx for JavaScript
 *
 * Passwords must be
 * - At least 8 characters long, max length anything
 * - Include at least 1 lowercase letter
 * - 1 capital letter
 * - 1 number
 * - 1 special character => !@#$%.^&*
 */
export const NameValidation = [
  { required: true, message: "Name is required" },
  { pattern: /^[A-Za-zÀ-ÖØ-öø-ÿ'’. ]+$/, message: "Name must have only letters" },
  { min: 2, message: "Name must have minimum of 2 letters" },
];

export const passwordRegex =
  /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[\w|!?@#$%.^&*:;.><])[\w|!?@#$%.^&*:;.><]{8,}$/;

export const numbersAndLettersRegex = /[^\w]|_/g;
export const TeamMemberPriceImputValidation = /^\d{1,18}(\.\d{1,2})?$/g;
export const MaxFileSize = 1500000; //1MB = 1 500 000 bytes
export const MaxFileNameSize = 50;
export const FilesLimit = 99;
export const AcceptedFiles = [
  /*IMAGES*/
  ".png",
  ".jpg",
  ".jpeg",
  /*Text+Word*/
  ".txt",
  ".pdf",
  ".docx",
  /*Exel*/
  ".xlsx",
];

export const Months = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};
export const MonthsAsNumbers = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

export const MonthsPortuguese = {
  1: "Janeiro",
  2: "Fevereiro",
  3: "Março",
  4: "Abril",
  5: "Maio",
  6: "Junho",
  7: "Julho",
  8: "Agosto",
  9: "Setembro",
  10: "Outubro",
  11: "Novembro",
  12: "Dezembro",
};

export const Month = {
  Zero: 0,
  One: 1,
  Two: 2,
  Three: 3,
  Four: 4,
  Five: 5,
  Six: 6,
  Seven: 7,
  Eight: 8,
  Nine: 9,
  Ten: 10,
  Eleven: 11,
  Twelve: 12,
};

export const AwardsInstallments = {
  0: "NoInstallmentPaid",
  1: "FirstInstallmentPaid",
  2: "SecondInstallmentPaid",
};

export const Position = {
  TeamLeaderHumanCapital: 8,
  Nexel: 20,
};

export const Roles = {
  Admin: 1,
  HumanResources: 2,
  Manager: 3,
};

export const EmployeeTabs = {
  Details: 1,
  Certifications: 2,
  FollowupEvents: 3,
  Offers: 4,
};

export const RolesDescription = {
  Admin: "Admin",
  HumanResources: "Human Resources",
  Manager: "Manager",
  MarketingCommunication: "Marketing Communications",
};

export const AssessmentResponses = {
  VeryDissatisfied: 1,
  Dissatisfied: 2,
  NotVerySatisfied: 3,
  Satisfied: 4,
  VerySatisfied: 5,
};

//Necessário ter AssessmentResponsesDescription em PT e em EN devido ao facto dos emails poderem ir em inglês ou português
export const AssessmentResponsesDescriptionPT = {
  VeryDissatisfied: "Muito insatisfeito",
  Dissatisfied: "Insatisfeito",
  NotVerySatisfied: "Pouco satisfeito",
  Satisfied: "Satisfeito",
  VerySatisfied: "Muito satisfeito",
};

export const AssessmentResponsesDescriptionEN = {
  VeryDissatisfied: "Very Dissatisfied",
  Dissatisfied: "Dissatisfied",
  NotVerySatisfied: "Not Very Satisfied",
  Satisfied: "Satisfied",
  VerySatisfied: "Very Satisfied",
};

export const ContractType = {
  CTI: 1,
  CPS: 2,
  CTC: 3,
  AcademyIEFP: 4,
  Academy: 5,
  Indefinido: 6,
  Autonomo: 7,
};
export const Departement = {
    Administrativo: 1,
    Manager: 2,
    Consultant: 3,
    HumanResources: 4,
    Marketing: 5,
    Directors: 7,
    Administration: 8,
    Formation: 9,
    ITS: 10,
    Corp: 11,
    TrainingCenter: 12,
    DT: 16,
    NearU: 17,
    DPG: 18,
    LABS: 19,
    Nexel: 99
};

export const WorkPlaces = {
  Lisboa: 1,
  Porto: 2,
  Internacional: 3,
  Aveiro: 4,
  Beja: 5,
  Braga: 6,
  Bragança: 7,
  CasteloBranco: 8,
  Coimbra: 9,
  Évora: 10,
  Faro: 11,
  Guarda: 12,
  Leiria: 13,
  Portalegre: 14,
  Santarém: 15,
  Setúbal: 16,
  VianaDoCastelo: 17,
  VilaReal: 18,
  Viseu: 19,
  Açores: 20,
  Madeira: 21,
};

export const phoneOptions = [
  {
    id: "noPhone",
    name: "No Phone",
  },
  {
    id: "hasPhone",
    name: "Has Phone",
  },
];

export const StatusOptions = [
  {
    id: "active",
    name: "Active",
  },
  {
    id: "inactive",
    name: "Inactive",
  },
];

export const ConsultantTypeOptions = [
  {
    id: 1,
    name: "Consultant",
  },
  {
    id: 2,
    name: "Internal",
  },
];

export const HiredTypeOptions = [
  {
    id: 1,
    name: "Hired",
  },
  {
    id: 2,
    name: "Resigned",
  },
];

// Funções para obter opções traduzidas
export const getConsultantTypeOptions = (t) => [
  {
    id: 1,
    name: t("consultantTypeOptions.consultant"),
  },
  {
    id: 2,
    name: t("consultantTypeOptions.internal"),
  },
];

export const getHiredTypeOptions = (t) => [
  {
    id: 1,
    name: t("hiredTypeOptions.hired"),
  },
  {
    id: 2,
    name: t("hiredTypeOptions.resigned"),
  },
];
export const TypeProjectOptions = [
  {
    id: 1,
    name: "Time and Materials",
  },
  {
    id: 2,
    name: "Fixed Fee",
  },
  {
    id: 3,
    name: "Key Turn Solution",
  },
];
export const ExperienceOptions = [
  {
    id: 1,
    name: "Junior",
  },
  {
    id: 2,
    name: "Consultant",
  },
  {
    id: 3,
    name: "Senior",
  },
];

export const offeredOptions = [
  {
    id: "foroffering",
    name: "For Offering",
  },
  {
    id: "offered",
    name: "Offered",
  },
];

export const FollowUpEventTypeColor = [
  {
    id: 1,
    color: "pink",
  },
  {
    id: 2,
    color: "green",
  },
  {
    id: 3,
    color: "green",
  },
  {
    id: 4,
    color: "blue",
  },
  {
    id: 5,
    color: "red",
  },
  {
    id: 6,
    color: "yellow",
  },
  {
    id: 7,
    color: "gray",
  },
  {
    id: 8,
    color: "orange",
  },
  {
    id: 9,
    color: "green",
  },
  {
    id: 10,
    color: "purple",
  },
  {
    id: 11,
    color: "yellow",
  },
  {
    id: 12,
    color: "gray",
  },
  {
    id: 13,
    color: "purple",
  },
  {
    id: 14,
    color: "yellow",
  },
  {
    id: 15,
    color: "gray",
  },
  {
    id: 16,
    color: "orange",
  },
];

export const QuizStatus = {
  Draft: 0,
  Published: 1,
  Unpublished: 2,
};

export const QuizStatusOptions = [
  {
    id: "0",
    name: "Draft",
  },
  {
    id: "1",
    name: "Published",
  },
  {
    id: "2",
    name: "Unpublished",
  },
];

// enum of Follow Up Event Status
export const FollowUpEventStatus = {
  NotAssigned: 0,
  NotDone: 1,
  Done: 2,
  Canceled: 3,
};

// get list of option for Follow Up Event Status
export const getFollowUpEventStatus = () => {
  const list = [];
  Object.keys(FollowUpEventStatus).forEach((value, key) => {
    list.push({
      id: key.toString(),
      name: value.split(/(?=[A-Z])/).join(" "),
    });
  });
  return list;
};

export const EmployeeFollowUpEventQuizStatus = {
  NoQuiz: 0,
  AwaitsResponseFromConsultant: 1,
  AwaitsResponseFromSupervisor: 2,
  Answered: 3,
};

// enum of Answer Types
export const AnswerType = {
  RespostaAberta: 1,
  VerdadeiroFalso: 2,
  EscolhaUnica: 3,
  EscolhaMultipla: 4,
  Data: 5,
  Escala: 6,
};

export const AnsweredByOptions = [
  {
    id: 1,
    name: "Consultant",
  },
  {
    id: 2,
    name: "Supervisor",
  },
  {
    id: 3,
    name: "Both",
  },
];

// enum of Answer By
export const AnsweredBy = {
  Consultant: 1,
  Supervisor: 2,
  Both: 3,
};

export const QuizAnsweredBy = {
  Supervisor: 0,
  Consultant: 1,
};

export const getAnsweredBy = () => {
  const list = [];
  Object.keys(QuizAnsweredBy).forEach((value, key) => {
    list.push({
      id: key,
      name: value.split(/(?=[A-Z])/).join(" "),
    });
  });
  return list;
};

export const OfferStatus = {
  NotDelivered: 0,
  Delivered: 1,
  Canceled: 2,
};

export const MonthlyStatus = {
  Previous: 0,
  Current: 1,
  Next: 2,
};

export const CriticalSituationStatus = {
  FollowingUp: 0,
  Closed: 1,
};
export const getCriticalSituationOptions = () => {
  const op = [];
  Object.keys(CriticalSituationStatus).forEach((value, key) => {
    op.push({
      id: key,
      name: value.split(/(?=[A-Z])/).join(" "),
    });
  });
  return op;
};

export const EmailListName = {
  LisbonHumanCapitalManagement: "_HC Gestão Lisboa",
  PortoHumanCapitalManagement: "_HC Gestão Porto",
};

export const FollowUpEventFor = {
  All: 0,
  Consultant: 1,
  Academy: 2,
  Nexel: 3,
};
export const getFollowUpEventForOptions = () => {
  const op = [];
  Object.keys(FollowUpEventFor).forEach((value, key) => {
    op.push({
      id: key,
      name: value.split(/(?=[A-Z])/).join(" "),
    });
  });
  return op;
};

export const ErrorSuffix = "_error";
export const NotApplicableSuffix = "_na";
export const EmployeeSuffix = "_emp";
export const NotApplicableLabel = "Not Applicable";
